export default __webpack_public_path__ + "img/fec572938fc91013134eff0a84bab85b.svg";